// extracted by mini-css-extract-plugin
module.exports = {"tab-content":"a630f0e637--tab-content--dbSq_","icon":"a630f0e637--icon--oKvva"};